module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.stats.total == _vm.stats.success) ? _c('p', [_vm._v("\n    Wysłano poprawnie do wszystkich: "), _c('strong', [_vm._v(_vm._s(_vm.stats.total))]), _vm._v(" subskrybentów!\n  ")]) : _vm._e(), _vm._v(" "), (_vm.stats.total != _vm.stats.success) ? _c('p', [_vm._v("\n      Próbowano wysłać do "), _c('strong', [_vm._v(_vm._s(_vm.stats.total))]), _vm._v(". Wysłano z powodzeniem: "), _c('strong', [_vm._v(_vm._s(_vm.stats.success))]), _vm._v(".Nie można było wysłać do "), _c('strong', [_vm._v(_vm._s(_vm.stats.failure))]), _vm._v(".\n  ")]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('th', [_vm._v("\n                E-mail\n            ")]), _vm._v(" "), _c('th', [_vm._v("\n                Wysłano\n                "), _c('sorting', {
    attrs: {
      "sort": _vm.meta.sort,
      "key-for": 'send_on',
      "direction": _vm.meta.direction
    },
    on: {
      "change-order": _vm.changeOrder
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("\n                Status\n                "), _c('sorting', {
    attrs: {
      "sort": _vm.meta.sort,
      "key-for": 'send_status',
      "direction": _vm.meta.direction
    },
    on: {
      "change-order": _vm.changeOrder
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_vm._v("\n                " + _vm._s(item.email.email) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(item.send_on_formated) + "\n            ")]), _vm._v(" "), _c('td', [(item.send_status == 1) ? _c('span', {
      staticClass: "badge badge-gray"
    }, [_vm._v("Wysłano")]) : _vm._e(), _vm._v(" "), (item.send_status != 1) ? _c('span', {
      staticClass: "badge badge-alert"
    }, [_vm._v("Nie można było wysłać")]) : _vm._e()])])
  })], 2), _vm._v(" "), _c('basic-pagination', {
    attrs: {
      "meta": _vm.meta
    },
    on: {
      "pagination-page": _vm.changePage,
      "pagination-limit": _vm.changeLimit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e8fbb95","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/messages/SendLog.vue
// module id = 262
// module chunks = 0